export enum OtlMode {
  ADD_CREDIT_CARD = 'addCreditCard',
  RULES_SETTINGS = 'ruleSettings'
}

export type ModifiedCreditCard = {
  creditcardId: number;
  creditCardType: string;
  cardLastDigits: string;
  paymentMethod: string;
};
